import { t } from './i18n.es.js';
import { getProductUrl } from '@teko/discovery';
import { ORDER_SHIPMENT_STATUS, STATUS_COLOR, CONSUMER_ORDER_STATUSES, ORDER_TAB_DONE } from './constants.es.js';

const getOrderStatus = (record) => {
    const status = record.computedStatus.displayStatus;
    const statusColor = record.computedStatus.color;
    return { status, statusColor };
};
const getShipmentStatus = (status, shipmentStatuses = ORDER_SHIPMENT_STATUS) => {
    return (shipmentStatuses.find((shipmentStatus) => shipmentStatus.status === status) || { color: STATUS_COLOR.processing, displayStatus: t('Chờ giao hàng') });
};
const ORDER_WAITING_PAYMENT_STATE = [
    'CREATED',
    'WAITING_FOR_PAYMENT_CONFIRMATION',
];
const getOrderCustomerState = (status) => {
    const orderDeliveringState = ['DELIVERING'];
    const orderWaitingForDeliveryState = [
        'PAID',
        'WAIT_FOR_PROCESS',
        'PROCESSING',
    ];
    if (orderDeliveringState.includes(status))
        return 2;
    if (orderWaitingForDeliveryState.includes(status))
        return 1;
    if (ORDER_WAITING_PAYMENT_STATE.includes(status))
        return 0;
    if (CONSUMER_ORDER_STATUSES.filter((orderState) => orderState.tab === ORDER_TAB_DONE)
        .map((orderState) => orderState.status)
        .includes(status))
        return 3;
    return 0;
};
const DELIVERY_SERVICE_GROUP_ID = 1;
const TECHNICAL_SUPPORT_SERVICE_ID = 5;
const SHOWROOM_SERVICE_ID = 4;
const EVOUCHER_PAYMENT_METHOD = 'PMH';
const SHIPPING_SKU = '1206838';
const TECHNICAL_SUPPORT_SKU = '1702079';
const getGifts = (product, products, promotions) => {
    const gifts = [];
    promotions.map((promotion) => {
        var _a, _b;
        if (promotion.applyType === 'product' &&
            ((_b = (_a = promotion === null || promotion === void 0 ? void 0 : promotion.applyOn) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.lineItemId) === product.lineItemId &&
            !!promotion.gifts.length) {
            promotion.gifts.map((gift) => {
                const product = products.find((product) => product.sku === gift.sku);
                product &&
                    gifts.push({
                        name: product.name,
                        price: product.price,
                        quantity: gift.quantity,
                        imageUrl: gift.image,
                    });
            });
        }
    });
    return gifts;
};
const convertItems = (product, gifts, skuImageMapping = new Map()) => {
    return Object.assign(Object.assign({}, product), { imageUrl: product.imageUrl
            ? product.imageUrl
            : skuImageMapping[product.sku], finalPrice: product.rowTotal, price: product.price, link: {
            as: getProductUrl(product.name, product.sku),
            href: { pathname: '/products/[sku]', query: { sku: product.sku } },
            passHref: true,
        }, isGift: !!gifts.length &&
            gifts.findIndex((gift) => gift.lineItemId === product.lineItemId) !==
                -1 });
};
const convertOrderDetail = (data) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { items, promotions, routerItems, serviceFee, shipments, grandTotal, discountApproval, skuImageMapping = new Map(), } = data;
    const gifts = (promotions || []).reduce((total, promotion) => [...total, ...((promotion === null || promotion === void 0 ? void 0 : promotion.gifts) || [])], []);
    const orderPromotion = (promotions || []).find((promo) => promo.applyType === 'order' && !promo.coupon);
    const orderCouponPromotion = (promotions || []).find((promo) => promo.applyType === 'order' && promo.coupon);
    const subTotalOrder = items
        .filter((product) => !product.isGift)
        .reduce((subTotal, current) => {
        return subTotal + current.unitPrice * current.quantity;
    }, 0);
    const shippingFee = (serviceFee === null || serviceFee === void 0 ? void 0 : serviceFee.delivery.reduce((total, delivery) => {
        const { groupId, price } = delivery;
        return total + (groupId === DELIVERY_SERVICE_GROUP_ID ? price : 0);
    }, 0)) || 0;
    const installationFee = ((serviceFee === null || serviceFee === void 0 ? void 0 : serviceFee.optional) || []).reduce((total, delivery) => {
        const { id, price } = delivery;
        return total + (id === TECHNICAL_SUPPORT_SERVICE_ID ? price : 0);
    }, 0) || 0;
    const hasShowroomService = serviceFee === null || serviceFee === void 0 ? void 0 : serviceFee.delivery.find((service) => service.id === SHOWROOM_SERVICE_ID);
    const discount = data
        ? subTotalOrder +
            shippingFee -
            (((_b = (_a = data === null || data === void 0 ? void 0 : data.technicalSupportFee) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.price) || 0) -
            grandTotal
        : 0;
    const unitAdd = items.reduce((unitAdd, product) => {
        return unitAdd + (product.unitAdd || 0) * product.quantity;
    }, 0);
    const totalFee = shippingFee + installationFee;
    const defaultPartOrderPromotion = promotions === null || promotions === void 0 ? void 0 : promotions.find(({ isDefault, coupon, applyType }) => isDefault && coupon && applyType === 'part_order');
    const partOrderDiscount = (defaultPartOrderPromotion === null || defaultPartOrderPromotion === void 0 ? void 0 : defaultPartOrderPromotion.discount) || 0;
    const promotionsDiscount = (promotions || []).reduce((total, promotion) => total +
        (promotion.applyType !== 'product' &&
            !(promotion.isDefault && promotion.coupon)
            ? promotion.discount
            : 0), 0);
    const comboPromotionDiscount = (promotions || []).reduce((total, promotion) => total +
        (promotion.applyType === 'combo' && !promotion.isDefault
            ? promotion.discount
            : 0), 0);
    const subTotal = grandTotal -
        totalFee -
        unitAdd +
        partOrderDiscount +
        promotionsDiscount +
        ((discountApproval === null || discountApproval === void 0 ? void 0 : discountApproval.amount) || 0) -
        comboPromotionDiscount;
    const partOrderPromotion = promotions === null || promotions === void 0 ? void 0 : promotions.filter(({ coupon, applyType }) => coupon && applyType === 'part_order');
    const comboPromotion = promotions === null || promotions === void 0 ? void 0 : promotions.filter(({ coupon, applyType }) => !coupon && applyType === 'combo');
    const totalShipment = shipments === null || shipments === void 0 ? void 0 : shipments.length;
    const eVoucherAmount = ((_d = (_c = data === null || data === void 0 ? void 0 : data.payments) === null || _c === void 0 ? void 0 : _c.find(({ paymentMethod }) => paymentMethod === EVOUCHER_PAYMENT_METHOD)) === null || _d === void 0 ? void 0 : _d.amount) || 0;
    const comboParentsPromotion = (promotions || []).find((promo) => promo.applyType === 'combo');
    const comboParentGifts = (comboParentsPromotion === null || comboParentsPromotion === void 0 ? void 0 : comboParentsPromotion.gifts) || [];
    const comboParentVoucher = (comboParentsPromotion === null || comboParentsPromotion === void 0 ? void 0 : comboParentsPromotion.voucher) || {};
    const nonProductPromotions = [
        ...(partOrderPromotion || []),
        ...(comboPromotion || []),
        orderPromotion,
    ].filter((promotion) => promotion &&
        !(promotion.discount &&
            !promotion.gifts.length &&
            !promotion.voucher.quantity));
    const expectedDate = (_e = data === null || data === void 0 ? void 0 : data.shippingInfo) === null || _e === void 0 ? void 0 : _e.expectedDate;
    if (expectedDate) {
        data.shippingInfo.expectedDate = new Date(expectedDate.replace(' ', 'T'));
    }
    const item2promotion = promotions.reduce((prev, curr) => {
        for (const item of curr.applyOn) {
            if (!prev.has(item.lineItemId)) {
                prev.set(item.lineItemId, []);
            }
            prev.get(item.lineItemId).push(curr);
        }
        return prev;
    }, new Map());
    const orderItems = (!!items.length &&
        items
            .filter((product) => product.sku !== SHIPPING_SKU &&
            product.sku !== TECHNICAL_SUPPORT_SKU)
            .map((product) => {
            return Object.assign(Object.assign({}, convertItems(product, gifts, skuImageMapping)), { prizes: getGifts(product, items, promotions), promotions: item2promotion.get(product.lineItemId) || [] });
        })) ||
        [];
    const convertedShipments = (_f = data.shipments) === null || _f === void 0 ? void 0 : _f.map((shipment) => (Object.assign(Object.assign({}, shipment), { routerItems: shipment.routerItems.map((routerItem) => convertItems(routerItem, gifts, skuImageMapping)) })));
    const orderDetail = Object.assign(Object.assign({}, data), { eVoucherAmount,
        totalShipment, items: orderItems, shipments: convertedShipments, routerItems: (!!(routerItems === null || routerItems === void 0 ? void 0 : routerItems.length) &&
            routerItems
                .filter((product) => product.sku !== SHIPPING_SKU &&
                product.sku !== TECHNICAL_SUPPORT_SKU)
                .map((product) => {
                return Object.assign(Object.assign({}, convertItems(Object.assign(Object.assign({}, product), { imageUrl: items.find((item) => item.sku === product.sku).imageUrl ||
                        product.imageUrl, price: product.price > -1
                        ? product.price
                        : items.find((item) => item.lineItemId === product.lineItemId).price }), gifts, skuImageMapping)), { prizes: [] });
            })) ||
            [], shippingFee, technicalSupportFee: installationFee, totalFee, orderDiscount: promotionsDiscount - comboPromotionDiscount, defaultPartOrderPromotion,
        partOrderPromotion,
        comboPromotion,
        hasShowroomService,
        orderPromotion,
        partOrderDiscount,
        orderCouponPromotion,
        discount,
        subTotalOrder,
        subTotal,
        unitAdd,
        comboParentGifts,
        comboParentVoucher, nonProductPromotions: nonProductPromotions.map((promo) => {
            return Object.assign(Object.assign({}, promo), { gifts: promo.gifts.map((item) => {
                    const product = orderItems.find((product) => product.sku === item.sku);
                    return Object.assign(Object.assign({}, item), { imageUrl: (product === null || product === void 0 ? void 0 : product.imageUrl) || skuImageMapping[product.sku] });
                }) });
        }), get totalItems() {
            return orderItems.reduce((total, item) => total + item.quantity - item.cancelledQuantity, 0);
        },
        get customerState() {
            return getOrderCustomerState(data.status);
        }, totalPriceDifference: ((_g = orderItems === null || orderItems === void 0 ? void 0 : orderItems.map((item) => ((item === null || item === void 0 ? void 0 : item.unitAdd) || 0) * ((item === null || item === void 0 ? void 0 : item.quantity) || 0))) === null || _g === void 0 ? void 0 : _g.reduce((prevValue, currentValue) => currentValue + prevValue, 0)) || 0 });
    if (!!orderDetail.skuImageMapping)
        delete orderDetail.skuImageMapping;
    return orderDetail;
};

export { TECHNICAL_SUPPORT_SKU, convertOrderDetail, getOrderCustomerState, getOrderStatus, getShipmentStatus };
